export default function draw3DShapeOnCanvas(canvas, idx) {
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = "#e74c3c"; // different color for 3D shapes
    ctx.lineWidth = 3;
    ctx.beginPath();
    switch (idx) {
      case 0: // Cube: draw two overlapping squares and connect corners
        ctx.rect(50, 50, 100, 100);
        ctx.rect(80, 80, 100, 100);
        ctx.moveTo(50, 50);
        ctx.lineTo(80, 80);
        ctx.moveTo(150, 50);
        ctx.lineTo(180, 80);
        ctx.moveTo(50, 150);
        ctx.lineTo(80, 180);
        ctx.moveTo(150, 150);
        ctx.lineTo(180, 180);
        break;
      case 1: // Rectangular Prism: a stretched cube
        ctx.rect(40, 60, 120, 80);
        ctx.rect(70, 90, 120, 80);
        ctx.moveTo(40, 60);
        ctx.lineTo(70, 90);
        ctx.moveTo(160, 60);
        ctx.lineTo(190, 90);
        ctx.moveTo(40, 140);
        ctx.lineTo(70, 170);
        ctx.moveTo(160, 140);
        ctx.lineTo(190, 170);
        break;
      case 2: // Pyramid (square pyramid)
        ctx.rect(60, 100, 100, 60); // base
        let apexX = 110, apexY = 40;
        ctx.moveTo(60, 100);
        ctx.lineTo(apexX, apexY);
        ctx.moveTo(160, 100);
        ctx.lineTo(apexX, apexY);
        ctx.moveTo(160, 160);
        ctx.lineTo(apexX, apexY);
        ctx.moveTo(60, 160);
        ctx.lineTo(apexX, apexY);
        break;
      case 3: // Triangular Prism (simplified)
        // left triangle
        ctx.moveTo(50, 70);
        ctx.lineTo(50, 150);
        ctx.lineTo(100, 110);
        ctx.closePath();
        // right triangle (offset)
        ctx.moveTo(90, 90);
        ctx.lineTo(90, 170);
        ctx.lineTo(140, 130);
        ctx.closePath();
        // connecting edges
        ctx.moveTo(50, 70);
        ctx.lineTo(90, 90);
        ctx.moveTo(50, 150);
        ctx.lineTo(90, 170);
        ctx.moveTo(100, 110);
        ctx.lineTo(140, 130);
        break;
      case 4: // Cylinder
        ctx.ellipse(100, 80, 50, 20, 0, 0, 2 * Math.PI);
        ctx.ellipse(100, 140, 50, 20, 0, 0, 2 * Math.PI);
        ctx.moveTo(50, 80);
        ctx.lineTo(50, 140);
        ctx.moveTo(150, 80);
        ctx.lineTo(150, 140);
        break;
      case 5: // Sphere
        ctx.arc(100, 110, 50, 0, 2 * Math.PI);
        ctx.moveTo(50, 110);
        ctx.lineTo(150, 110);
        ctx.moveTo(100, 60);
        ctx.lineTo(100, 160);
        break;
      default:
        break;
    }
    ctx.stroke();
  }
  